import axios from 'axios'

axios.defaults.baseURL = process.env.BASE_URL + '/api/v1'

export default axios



// WEBPACK FOOTER //
// ./src/common/axios.js